export const EXTERNAL_LINK_ARIA_LABEL = 'Opens in new tab';
